import '../App.css'
import { useSelector } from 'react-redux'
import Footer from '../components/Footer/Footer'
import Login from '../components/Login/Login'
import NavBar from '../components/NavBar/NavBar'
import { Navigate } from 'react-router-dom'

function Admin () {
 const user = useSelector(state=> state.us.current);

 if (user) {
   return <Navigate to='/admin/list-users' />
 } else 
 {

     return<>

  <div className='page-container'>

 <NavBar role={'Admin Login'}/>
   <div className='content-wrap'>

  <Login title={'Administrator'}/>
   </div>

 <Footer/>
 
  </div>
 </> 
}
}

export default Admin